import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, X } from 'lucide-react';
import { products } from '../mock';
import { useWishlist } from '../context/WishlistContext';
import ProductCard from '../components/ProductCard';
import Seo from '../components/Seo';

const Wishlist = () => {
  const { slugs, remove, clear } = useWishlist();
  const saved = products.filter(p => slugs.includes(p.slug));

  return (
    <main className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-16">
      <Seo title="Wishlist | Vial Rat Research Co." description="Your saved specimens." canonicalPath="/wishlist" noindex />
      <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-4">SAVED FOR LATER</div>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <h1 className="font-serif-display text-white text-5xl md:text-6xl">The Vault</h1>
        {saved.length > 0 && (
          <button onClick={clear} className="font-mono-label text-[11px] text-neutral-400 hover:text-[#ff2fa1] transition-colors">
            CLEAR VAULT
          </button>
        )}
      </div>

      {saved.length === 0 ? (
        <div className="mt-20 text-center py-20 border border-white/5 rounded-lg bg-[#101013]">
          <div className="w-16 h-16 rounded-full bg-[#ff2fa1]/10 border border-[#ff2fa1]/30 flex items-center justify-center mx-auto mb-6">
            <Heart size={26} className="text-[#ff2fa1]" />
          </div>
          <h2 className="font-serif-display text-white text-3xl mb-3">No specimens saved yet</h2>
          <p className="text-neutral-400 max-w-md mx-auto mb-8">Tap the heart on any specimen and it'll live here on this device so you can come back to it.</p>
          <Link to="/shop" className="btn-pink px-8 py-4 rounded font-mono-label text-[11px] inline-block">BROWSE CATALOG</Link>
        </div>
      ) : (
        <>
          <div className="mt-8 font-mono-label text-[11px] text-neutral-500">{saved.length} SAVED SPECIMEN{saved.length === 1 ? '' : 'S'}</div>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {saved.map(p => (
              <div key={p.slug} className="relative group">
                <ProductCard product={p} />
                <button onClick={() => remove(p.slug)} aria-label="Remove from vault"
                  className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-black/70 hover:bg-[#ff2fa1] hover:text-black text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <X size={14} />
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      <div className="mt-16 p-6 border border-[#ff2fa1]/20 bg-[#ff2fa1]/5 rounded">
        <div className="font-mono-label text-[11px] text-[#ff2fa1]">FOR RESEARCH USE ONLY</div>
        <p className="text-sm text-neutral-400 mt-2">Products are intended for laboratory and research purposes only. Not for human or veterinary use, food, or household application.</p>
      </div>
    </main>
  );
};

export default Wishlist;
